define('Bazaarvoice', ['Profile.Model', 'jQuery', 'underscore', 'Utils'], function (
  ProfileModel,
  jQuery,
  _,
  Utils
) {
  'use strict';

  return {
    mountToApp: function (container) {
      var layout = container.getComponent('Layout');
      var environment = container.getComponent('Environment');

      if (!environment || !layout) {
        return;
      }

      if (!Utils.isPageGenerator()) {
        this.addBVLoader(environment);
      }

      this.addTrackers(environment, layout);
    },

    addBVLoader: function (environment) {
      if (!environment.getConfig('bazaarvoice.bvLoaderScript')) {
        return;
      }

      // Create script element to append to the head of the site
      var script = _.extend(document.createElement('script'), {
        async: true,
        type: 'text/javascript',
        src: environment.getConfig('bazaarvoice.bvLoaderScript')
      });

      // Append it to the document
      document.head.append(script);
    },

    addTrackers: function (environment, layout) {
      var self = this;

      environment.addTracker({
        trackProductView: function (product) {
          window.bvDCC = {
            catalogData: {
              locale: 'en_US',
              catalogProducts: [
                {
                  productId: product.sku,
                  productName: product.name,
                  productImageURL: product.thumbnail,
                  productPageURL: window.location.origin + product.urlComponent,
                  brandName: '',
                  upcs: [product.sku],
                  inactive: false,
                  family: ''
                }
              ]
            }
          };

          window.bvCallback = function (BV) {
            BV.pixel.trackEvent('CatalogUpdate', {
              type: 'Product',
              locale: window.bvDCC.catalogData.locale,
              catalogProducts: window.bvDCC.catalogData.catalogProducts
            });
          };

          layout.modifyViewJsonLd('ProductDetails.Full.View', function (json) {
            json = _.extend(json, {
              '@id': window.location.origin + product.urlComponent
            });

            return jQuery.Deferred().resolve(json);
          });
        },

        trackTransaction: function (transaction, event) {
          window.bvCallback = function (BV) {
            var profile = ProfileModel.getInstance();

            BV.pixel.trackTransaction({
              orderId: transaction.confirmationNumber, // provided by your system
              currency: 'USD',
              total: self.round(transaction.subTotal, 2), // subtotal without tax, shipping, discounts
              tax: self.round(transaction.taxTotal, 2),
              shipping: self.round(transaction.shippingCost, 2),
              items: _.map(transaction.products, function (product) {
                return {
                  name: product.name,
                  price: self.round(product.price, 2),
                  quantity: product.quantity,
                  productId: product.sku
                };
              }),
              email: profile.get('email'),
              locale: 'en_US',
              nickname: profile.get('name') // used for email personalization
            });
          };
        }
      });
    },

    round: function (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(2);
    }
  };
});
